import DynamicTable from "../../../components/tables/dynamicTable";
import Sidebar from "../../../components/sidebar/Sidebar";
import NavBar from "../../../components/navbar/NavBar";
import { config } from "../../../config/Constants";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Axios from "axios";

//get exception report data main function
const ExceptionReport = () => {
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {getExceptionData();}, []);

  // Get the data for the report and set
  const getExceptionData = async () => {
    const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: "exceptionreport",
        companyName: Cookies.get("cp-cn"),
      },
    });
    const dataObject = {
      data: formatData(response.data.report.recordset),
      size: "small",
    };
    setLoading(false);
    setFilteredData(dataObject.data);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA").trim();
  };
  const formatData = (data) => {
    return data.map((item) => {
      const updatedItem = {
        ...item,
        "PICKUP_DATE": item["PICKUP_DATE"] ? formatDate(item["PICKUP_DATE"]) : "N/A",
        "EXCEPTED_DELIVERY_DATE": item["EXCEPTED_DELIVERY_DATE"] ? formatDate(item["EXCEPTED_DELIVERY_DATE"]) : "N/A",
        "EXCEPTION_DATE": item["EXCEPTION_DATE"] ? formatDate(item["EXCEPTION_DATE"]) : "N/A"
      };
  
      if (item["NEW_EXPECTED_DELIVERY_DATE"]) {
        const newDate = new Date(item["NEW_EXPECTED_DELIVERY_DATE"]);
        newDate.setDate(newDate.getDate() + 1);
        updatedItem["NEW_EXPECTED_DELIVERY_DATE"] = formatDate(newDate.toISOString());
      } else {
        updatedItem["NEW_EXPECTED_DELIVERY_DATE"] = "Not Returned in the API";
      }
  
      return updatedItem;
    });
  };

  return (
    <div className="serviceStatsPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="tableReportsPageContent">
          <div className="scoreBoardTitle">
            <h1>Exception Report</h1>
           </div>
          <div className="reportSpace">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div className="report" style = {{'margin-top': '5px'}}>
                <DynamicTable
                  dataObject={{ data: filteredData, size: "small" }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExceptionReport;
